import { useCountdownSecondsUntil } from '@execonline-inc/react-hooks.private';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { T } from '../Translations';
import Modal from '../components/Modal';

interface Props {
  expiration: Date;
  reset: () => void;
}

export function WarningModal({ expiration, reset }: Props) {
  return (
    <Modal close={reset} title={<Title />}>
      <SecondsRemaining expiration={expiration} />
      <div className="my-7.5 flex justify-between">
        <LogoutButton />
        <ResumeActivityButton reset={reset} />
      </div>
    </Modal>
  );
}

function Title() {
  return (
    <h2
      className={clsx(
        'py-5 pr-12 pl-5 text-center leading-5 text-black lg:pr-2.5',
        'my-0 ml-0 mr-2.5 text-2xl font-medium normal-case tracking-normal',
      )}
      data-test-modal-title={true}
    >
      <T kind="Logging Out Soon Due to Inactivity" />
    </h2>
  );
}

function SecondsRemaining({ expiration }: { expiration: Date }) {
  const countdown = useCountdownSecondsUntil(expiration);

  return (
    <p className="mb-1">
      <T
        kind="You will automatically be logged out in {{count}} second"
        count={countdown.seconds}
      />
    </p>
  );
}

function LogoutButton() {
  return (
    <Link
      to="/logout"
      className={clsx(
        'inline-block cursor-pointer whitespace-nowrap capitalize tracking-wide',
        'rounded-sm border-solid border-transparent py-2 px-4 text-sm text-white',
        'bg-zinc-600 text-center font-light',
      )}
    >
      <T kind="Log Out" />
    </Link>
  );
}

function ResumeActivityButton({ reset }: { reset: Props['reset'] }) {
  return (
    <button
      className={clsx(
        'inline-block cursor-pointer whitespace-nowrap text-center',
        'rounded-sm border-solid border-transparent py-2 px-4 font-light tracking-wide',
        'bg-green-600 text-sm text-white',
      )}
      onClick={reset}
      data-test-resume-button={true}
    >
      <T kind="Stay Logged In" />
    </button>
  );
}
